import { createContext } from "react";

/**
 * AuthContext
 *
 * Provides authentication / admin credentials and theme state to any component
 * in the tree without prop-drilling through every page.
 *
 * Shape of the context value (set in App.js):
 *   {
 *     admin:    { title: string, access: string } | false,
 *     darkmode: boolean,
 *     appTheme: () => void   // toggles darkmode
 *   }
 */

// Note that I had Sonnet add darkmode and appTheme to authContext, to support
// future pages that wanted dark mode without explicitly passing props
// from App.js, however it was rather after the fact, and it's doubtful
// I will actually do that, and it could probably be removed.  Still, 
// I'll leave it in for now. AuthContext is pretty cool after all.

// Claude Sonnet's notes:
// Note: Individual pages still receive darkmode via props.darkmode from 
// App.js for their own page-level styling (class names, conditional rendering). 
// That prop-drilling is intentional and untouched — the context now covers the 
// shared TopNav use case. Any other component that needs darkmode or appTheme 
// in the future can simply call useContext(AuthContext) without any additional
//  wiring.
const AuthContext = createContext({
  admin: false,
  darkmode: false,
  appTheme: () => {},
});

export default AuthContext;
